export const imageHelper = (source, suffix = 'gatsbyImageData') => source?.imageFile?.childImageSharp[suffix]

export const altText = data => {
  let result = `Dye mushroom: ${data.latinName} (${data.commonName})`
  if (data.fiber && data.mordent) {
    result += `, Fiber: ${data.fiber}, Mordant: ${data.mordent.replace(/_/g, ' ')}`
  }
  else if (data.pigment) {
    result += `, Pigment: ${data.pigment.replace(/_/g, ' ')}`
  }
  return result
}
